import Home from '../views/Home.vue';
import Products from '../views/Products.vue';
import Case from '../views/Case.vue';
import About from '../views/About.vue';
import Service from '../views/Service.vue';
import VideoProcess from '../views/VideoProcess.vue';
import DeliveryInfo from '../views/DeliveryInfo.vue'
import InternalUseTools from '../views/InternalUseTools.vue'
export default [
	{
    path: '/',
    name: 'Index',
    redirect:'/home.html',
    meta: {
      requiresAuth: true
    },
    component: Home
  },
  {
    path: '/home.html',
    name: 'Home',
    meta: {
      requiresAuth: true
    },
    component: Home
  },
  {
    path: '/Products.html',
    name: 'Products',
    meta: {
      requiresAuth: true
    },
    component: Products
  },{
    path: '/Service.html',
    name: 'Service',
    meta: {
      requiresAuth: true
    },
    component: Service
  },{
  	path: '/Case.html',
    name: 'Case',
    meta: {
      requiresAuth: true
    },
    component: Case
  },{
    path: '/About.html',
    name: 'About',
    meta: {
      requiresAuth: true
    },
    component: About
  },
  {
    path:'/VideoProcess.html',
    name:'VideoProcess',
    meta: {
      requiresAuth: true
    },
    component: VideoProcess
  },
  {
    path:'/DeliveryInfo.html',
    name:'DeliveryInfo',
    meta: {
      requiresAuth: true
    },
    component: DeliveryInfo
  },{
    path:'/InternalUseTools.html',
    name:'InternalUseTools',
    meta: {
      requiresAuth: true
    },
    component: InternalUseTools
  },
  
]
